import React from 'react';

import { Header } from './Header';
import { Traceability } from './Traceability';
import { SelfHosted } from './SelfHosted';
import { Speed } from './Speed';
import { InvisibleMark } from './InvisibleMark';
import { Footer } from './Footer';

import { fadeEngine } from './Fade';
import { shadowEngine, ProjectionType } from './Shadow';

export function MainPage(): React.JSX.Element {

	React.useEffect( (): void => {
		shadowEngine.useEffect(ProjectionType.Orthographic, -500.0, 100.0, 400.0)
		fadeEngine.useEffect()
	}, [] );

		return (
				<div >
					{ /* The four claims, then one section for each: a copy traced
					     back to its recipient, where the service runs, the volumes
					     it is built for, the mark nobody sees. The figures live on
					     the Performances and Technology pages; the home page stays
					     in plain words and links out. */ }
					<Header />
					<Traceability />
					<SelfHosted />
					<Speed />
					<InvisibleMark />
					<Footer />
				</div>
		);

}
